import { Checkbox, Form } from "@/atoms"
import { useLogger } from "@/hooks/useLogger"

import styles from "./CommentsForm.module.scss"

import type { CommentsFormProps } from "."

export const CommentsForm = (props: CommentsFormProps) => {
  const { id, form, onFieldsChange, enableComments, name, label } = props
  const { logger } = useLogger()

  return (
    <Form
      form={form}
      id={id}
      initialValues={{ enableComments }}
      onFieldsChange={onFieldsChange}
      onFinish={({ enableComments }) => {
        props.onUpdate({ data: { id, enableComments } }, { name })

        if (props.mixPanelEvent)
          logger.info(props.mixPanelEvent, { enableComments })
      }}
    >
      <Form.Item
        name="enableComments"
        valuePropName="checked"
        className={styles.item}
      >
        <Checkbox>{label}</Checkbox>
      </Form.Item>
    </Form>
  )
}
